import { p as promiseResolve, b as bootstrapLazy } from './index-ea84587e.js';

/*
 Stencil Client Patch Esm v2.6.0 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["fg-product-images",[[0,"fg-product-images",{"images":[16],"currentImage":[32]}]]],["fg-product-slider",[[4,"fg-product-slider",{"products":[16],"fade":[4],"currentIndex":[32],"goTo":[64]}]]]], options);
  });
};

export { defineCustomElements };
